const shuffleArray = arr =>
  arr
    .map(a => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map(a => a[1]);

export const shuffledArray = numOfBlocks =>
  shuffleArray(new Array(numOfBlocks).fill().map((val, index) => index));

export default shuffleArray;



// WEBPACK FOOTER //
// ./src/helpers/shuffleArray.js